import {
  MOVE_STATUS_COLOR,
  MOVE_STATUS_DESCRIPTION,
  MOVE_STATUS_TRANSLATED,
} from '@/modules/move/entities/constants/move';
import { MOVE_STATUS } from '@/modules/move/entities/enums/move';
import React from 'react';
import { Chip } from 'vkit/lib/components';
import { Tooltip } from 'vkit/lib/context';

export interface StatusProps {
  label: string;
}

const Status: React.FC<StatusProps> = ({ label }) => (
  <Tooltip title={MOVE_STATUS_DESCRIPTION[label]}>
    <Chip
      size='small'
      label={label}
      color={MOVE_STATUS_COLOR[label]}
      rounded
      invertColor={label === MOVE_STATUS_TRANSLATED[MOVE_STATUS.NOT_INITIALIZED]}
    />
  </Tooltip>
);

export default Status;
